import React from "react";
import PropTypes from "prop-types";
import { PillInput } from "../../../components/PillInput/PillInput";
import { MODES } from "../../../configs";

const PillButtonGroup = ({
	data,
	mode,
	className,
	selectedType,
	isMobile,
	onChange,
	resetCruiseForm,
	setOpenCalendar,
	setShowPassengerPopover,
	setIsInitialSovMobileInputState,
	handleSovMobileInputSelectionToView,
}) => (
	<PillInput
		pillButtonLabel={data}
		mode={mode}
		isMobile={isMobile}
		classnames={className}
		selectedOption={selectedType}
		onChange={value => {
			if(["river", "ocean"].includes(selectedType)) {
				resetCruiseForm();
			}

			setShowPassengerPopover(false);

			handleSovMobileInputSelectionToView(
				selectedType === "multicity" ? "multicity-default" : "default",
				""
			);
			onChange(value);
			setOpenCalendar(false);
			setIsInitialSovMobileInputState(true)
		}}
	/>
);

PillButtonGroup.propTypes = {
	className: PropTypes.string,
	selectedType: PropTypes.oneOf([
		"RE",
		"OW",
		"MC",
		"roundtrip",
		"oneway",
		"multicity",
		"ocean",
		"river",
	]),
	mode: PropTypes.string,
	isMobile: PropTypes.bool,

	data: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			id: PropTypes.string,
			value: PropTypes.string,
		})
	).isRequired,

	onChange: PropTypes.func.isRequired,
	setOpenCalendar: PropTypes.func,
	resetCruiseForm: PropTypes.func,
	setShowPassengerPopover: PropTypes.func,
	setIsInitialSovMobileInputState: PropTypes.func,
	handleSovMobileInputSelectionToView: PropTypes.func,
};

PillButtonGroup.defaultProps = {
	className: undefined,
	selectedType: "RE",
	mode: MODES.SEARCH,
	isMobile: false,

	setOpenCalendar: ()=>{},
	setShowPassengerPopover: ()=>{},
	resetCruiseForm: ()=>{},
	setIsInitialSovMobileInputState: ()=>{},
	handleSovMobileInputSelectionToView: () => {},
};

export default PillButtonGroup;
export { PillButtonGroup };
